import * as React from 'react';
import { clsx } from 'clsx';
import styles from '../../styles/col.module.css';
import { useColProps } from './internal';
import { jsx as _jsx } from "react/jsx-runtime";
export const Col = props => {
  const {
    col,
    hidden,
    offset,
    offsetRight
  } = useColProps(props);
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles["col_".concat(col)], Boolean(offset) && [styles["col_offset_".concat(offset)]], Boolean(offsetRight) && styles["col_offset_right_".concat(offsetRight)]),
    children: props.children
  });
};
Col.displayName = 'Col';